import { axiosInstance } from "../api/axios";
import { toast } from "react-toastify";
import { ApiResponse } from "../models/ApiResponse";
import { UserExistsRequest } from "../models/UserExistsRequest";
import { CreateUserRequest } from "../models/CreateUserRequest";
import { User } from "../models/User";
import { Scope } from "../models/Scope";
import { ScopePermissions } from "../models/ScopePermissions";
import { Role } from "../models/Role";
import { ScopePermissionsResponse } from "../models/ScopePermissionsResponse";
import { UserListRequest } from "../models/UserListRequest";
import { DeleteUserRequest } from "../models/DeleteUserRequest";
import { EditUserRequest } from "../models/EditUserRequest";
import { BulkUploadUserRequest } from "../models/BulkUploadUserRequest";

export const userExist = async (data: UserExistsRequest) => {
  const result = await axiosInstance.post<ApiResponse<boolean>>("users/exists", data);
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }
  return false;
};

export const createUser = async (data: CreateUserRequest) => {
  const result = await axiosInstance.post<ApiResponse<User>>("users", data);
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }
  return false;
};

export const getRoles = async () => {
  const result = await axiosInstance.get<ApiResponse<Role[]>>("roles/all");
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }

  return [];
};

export const getScopes = async () => {
  const result = await axiosInstance.get<ApiResponse<Scope[]>>("scopes");
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }

  return [];
};

export const getUser = async (userId: number) => {
  const result = await axiosInstance.get<ApiResponse<User>>(`users/${userId}`);
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }

  return null;
};

export const getUserPermissions = async (userId: number) => {
  const result = await axiosInstance.get<ApiResponse<ScopePermissions[]>>(`users/${userId}/permissions`);
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }

  return null;
};

export const saveUserPermissions = async (userId: number, userPermissions: ScopePermissions[]) => {
  const result = await axiosInstance.put<ApiResponse<ScopePermissionsResponse>>(
    `users/${userId}/permissions`,
    userPermissions,
  );
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }

  return null;
};

export const getUsers = async (page: number, pageSize: number) => {
  let url = "users?";
  url += page ? `Page=${page}&` : "";
  url += pageSize ? `PageSize=${pageSize}&` : "";
  const result = await axiosInstance.get<ApiResponse<UserListRequest[]>>(url);

  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }

  return [];
};

export const deleteUser = async (userId: number, data: DeleteUserRequest) => {
  const result = await axiosInstance.delete<ApiResponse<DeleteUserRequest>>(`users/${userId}`, { data: data });
  if (result.data.statusCode === 200) {
    return true;
  } else {
    toast.error(result.data.status);
  }

  return false;
};

export const resendInvite = async (userId: number) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = await axiosInstance.put<ApiResponse<any>>(`users/${userId}/invitation/resend`);
  if (result.data.statusCode === 200) {
    return true;
  } else {
    toast.error(result.data.status);
  }

  return false;
};

export const editUserRequest = async (userId: number, data: EditUserRequest) => {
  const result = await axiosInstance.put<ApiResponse<EditUserRequest>>(`users/${userId}`, data);
  if (result.data.statusCode === 200) {
    return true;
  } else {
    toast.error(result.data.status);
  }
  return false;
};

export const bulkUploadUserRequest = async (userType: string, data: BulkUploadUserRequest[]) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = await axiosInstance.post<ApiResponse<any>>(`users/${userType}/bulkupload`, data);
  if (result.data.statusCode === 200) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const resultError: string[] = result?.data?.data;
    return resultError.length > 0 ? resultError : true;
  } else {
    toast.error(result.data.status);
  }
  return false;
};
